import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex-grow min-w-0" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-muted truncate"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "text-muted text-xs"
}

import type { UsesItemRecord } from '#shared/cms/records'
import { useDragAndDrop } from '@formkit/drag-and-drop/vue'

interface ItemEntry {
  rkey: string
  uri: string
  cid: string
  value: UsesItemRecord
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UsesItemDraggable',
  props: {
    items: {}
  },
  emits: ["reorder", "remove"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const [parent, values] = useDragAndDrop<ItemEntry>([...props.items], {
  dragHandle: '[data-drag-handle]',
})

watch(() => props.items, next => {
  // Sync local list when the parent re-fetches (e.g. after a save).
  values.value = [...next]
})

// Emit reorder when the order actually changes vs incoming props.
watch(values, next => {
  const before = props.items.map(i => i.rkey).join(',')
  const after = next.map(i => i.rkey).join(',')
  if (before !== after) emit('reorder', next)
}, { deep: false })

return (_ctx: any,_cache: any) => {
  const _component_NuxtLink = _resolveComponent("NuxtLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", {
      ref_key: "parent",
      ref: parent,
      class: "flex flex-col gap-2"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(values), (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.rkey,
          class: "flex items-center gap-3 bg-accent px-3 py-2"
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("span", {
            "data-drag-handle": "",
            class: "cursor-grab text-muted select-none"
          }, [
            _createElementVNode("span", { "aria-hidden": "true" }, "⋮⋮"),
            _createElementVNode("span", { class: "sr-only" }, "Drag to reorder")
          ], -1)),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_NuxtLink, {
              to: `/admin/uses/items/${item.rkey}`,
              class: "block underline-offset-4 hover:underline truncate"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.value.name), 1)
              ]),
              _: 2
            }, 1032, ["to"]),
            (item.value.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(item.value.description), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "text-sm text-muted hover:text-red-500 transition-colors",
            onClick: ($event: any) => (emit('remove', item.rkey, item.value.name))
          }, " Delete ", 8, _hoisted_3)
        ]))
      }), 128))
    ], 512),
    (!_unref(values).length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, " No items in this category. "))
      : _createCommentVNode("", true)
  ], 64))
}
}

})